import Contato from '../screens/Contato';

const route = [
  {
    path: '/contato',
    main: Contato,
  },
];

export default route;
